<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="contact-list">
      <Title :jpn="t('Contact us')" />
      {{ dispContactList }}
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      contactList: 'contact/contactList',
    }),
    dispContactList() {
      if (this.contactList) {
        if (this.contactList.list.length > 0) {
          return this.contactList.list;
        }
      }
      return [];
    },
  },

  components: {
    BaseTemplate,
    Title,
  },

  data: () => ({
    pageNumber: 1,
  }),

  created() {
    this.$store.dispatch('contact/setCurrentContact');
    const { pageNumber } = this;
    this.$store.dispatch('contact/setContactList', { pageNumber });
  },
};
</script>

<style lang="scss" scoped>
.contact-list {
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 90px;
  margin: 0px auto;
}
</style>
